module.exports = __webpack_public_path__ + "static/dashboard-hero-video-overlay-43d801600689a1337f1fab3758e21e58.png";